<template>
  <v-card flat>
    <v-card-title>New Invoice</v-card-title>
    <v-card-subtitle>
      <v-radio-group v-model="invoiceType" row required>
        <v-radio label="Overpayment" value="overpayment"></v-radio>
        <v-radio label="Reversal" value="reversal"></v-radio>
      </v-radio-group>
    </v-card-subtitle>

    <overpayment-invoice-form
      v-if="invoiceType === 'overpayment'"
    ></overpayment-invoice-form>
    <reversal-invoice-form
      v-if="invoiceType === 'reversal'"
    ></reversal-invoice-form>
  </v-card>
</template>
<script>
import OverpaymentInvoiceForm from "./overpayment-invoice-form";
import ReversalInvoiceForm from "./reversal-invoice-form";
export default {
  components: {
    OverpaymentInvoiceForm,
    ReversalInvoiceForm,
  },
  data() {
    return {
      invoiceType: "overpayment",
    };
  },
};
</script>
